import { useAccordion } from 'common/hooks/accordion';
import { useMatchesViewport } from 'common/hooks/media';
import { SectionName } from './enums';

const DEFAULT_EXPANDED_SECTIONS = [SectionName.General];

const useIsCollapsible = () => {
  const {
    matches: { matchesDesktop },
  } = useMatchesViewport();
  const isCollapsible = !matchesDesktop;

  return isCollapsible;
};

export const useFooterLinkSectionAccordion = () => {
  const isCollapsible = useIsCollapsible();
  const [toggle, isExpanded] = useAccordion(isCollapsible, DEFAULT_EXPANDED_SECTIONS);

  return {
    toggle,
    isExpanded,
    isCollapsible,
  };
};
